<template>
  <v-popup
    :class="bem()"
    :value="show"
    position="bottom"
    v-backFn="{ show: show, closeFn: 'close' }"
    @change="$emit('input', $event.target.value)"
    @click-overlay="close"
    :overlay="show"
    :get-container="container"
    id="vPopup"
    role="dialog"
    aria-modal="true"
    aria-hidden="false"
    :aria-label="`${title ? title : ''}弹[=tan2]层`"
  >
    <div :class="bem('container')" :style="{ height: height }">
      <div :class="bem('header')">
        <div
          class="img-back"
          ref="back"
          role="button"
          tabindex="0"
          aria-label="返回上一级"
          @click="back"
          v-if="backShow"
        ></div>
        <div :class="bem('title')" tabindex="0" ref="title" v-if="title">{{ title }}</div>
        <div
          ref="close"
          tabindex="0"
          :class="bem('close')"
          role="button"
          alt="关闭弹[=tan2]层"
          @click="close"
          v-if="closeShow"
        ></div>
      </div>
      <div :class="[bem('content'), { 'hidden-bottom': !footerShow }]">
        <slot />
      </div>
      <!--底部自定义-->
      <div v-if="$slots.footer" :class="[bem('footer')]">
        <slot name="footer" />
      </div>
      <div v-else-if="footerShow" :class="[bem('footer')]">
        <!-- 此组件已不用 -->
        <v-button position="center" type="frame-plus" @click="footerClick">{{ footerText }}</v-button>
      </div>
    </div>
  </v-popup>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import create from '../create'
import { hideSiblingEls, setAriaLiveByIds } from '@/utils/aria'

export default create({
  name: 'popups',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    // 是否显示
    show: {
      type: false,
      default: false
    },
    // 弹窗高度占全屏的百分比
    height: {
      type: String,
      default: 'auto'
    },
    // 弹窗标题
    title: String,
    // 是否展示返回按钮
    backShow: {
      type: Boolean,
      default: false
    },
    // 是否展示关闭按钮
    closeShow: {
      type: Boolean,
      default: true
    },
    // 底部按钮点击事件
    footerShow: {
      type: Boolean,
      default: true
    },
    // 底部按钮文案
    footerText: {
      type: String,
      default: '确定'
    },
    // 弹窗添加时所处的容器
    container: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState('detailv3', ['preFocusEl', 'ariaLiveElIds', 'isShowSkuSelect'])
  },
  methods: {
    ...mapMutations('detailv3', ['SET_VIDEO_CAN_PLAY_STATE', 'REMOVE_PREFOCUSEl']),
    back() {
      this.$emit('back')
    },
    close() {
      this.$emit('close')
    },
    footerClick() {
      this.$emit('footerClick')
    },
    focusEl(ref) {
      this.$refs?.[ref]?.focus()
    }
  },
  watch: {
    show: {
      handler(val, old) {
        // 解决非商详页使用该弹窗公共组件vuex没有该命名空间报错问题
        if (this.$store && 'detailv3' in this.$store._modules.root._children) {
          this['SET_VIDEO_CAN_PLAY_STATE'](!val)
          this.$nextTick(() => {
            if (val) {
              if (this.ariaLiveElIds && Array.isArray(this.ariaLiveElIds)) {
                setAriaLiveByIds(this.ariaLiveElIds, 'off')
              }
              setTimeout(() => {
                document.getElementById('app').setAttribute('aria-hidden', 'true')
              }, 500)
              if (this.$refs?.title) {
                this.$refs?.title?.focus()
              } else {
                this.$refs?.close?.focus()
              }
            } else {
              if (this.preFocusEl && !this.isShowSkuSelect) {
                if (this.preFocusEl?.length > 1) {
                  let nodeId = this.preFocusEl[this.preFocusEl.length - 1]
                  document.getElementById(nodeId)?.focus()
                  this['REMOVE_PREFOCUSEl']()
                } else {
                  setTimeout(() => {
                    document.getElementById('app').removeAttribute('aria-hidden')
                  }, 500)
                  document.getElementById(this.preFocusEl?.[0])?.focus()
                  this['REMOVE_PREFOCUSEl']()
                }
              }
            }
          })
        }
        this.$nextTick(() => {
          let doms = document.getElementsByClassName('v-overlay')
          for (let index = 0; index < doms.length; index++) {
            const element = doms[index]
            element.setAttribute('tabindex', '0')
            element.setAttribute('aria-label', '关闭弹[=tan2]窗')
          }
        })
      },
      immediate: true
    }
  }
})
</script>
<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss" scoped>
.v-popups {
  .v-popups__container {
    .v-popups__footer {
      ::v-deep .v-button {
        @include flex-inline-center();
      }
    }
  }
}
</style>
